module.exports = __webpack_public_path__ + "static/media/mo.b9856105.svg";